import Date from './Date'
import Search from './Search'
import Typeahead from './Typeahead'

const Input = {
  Date,
  Search,
  Typeahead,
}

export default Input
